import last from './last';

export default {
  cases: [last],
  name: 'Basic',
  // notes: 'Notes',
};
